<template>
  <div v-if="data" :class="['textblock', cssClasses]">
    <h2 v-if="data.title">{{ data.title }}</h2>
    <h3 v-if="data.subtitle">{{ data.subtitle }}</h3>
    <ul v-if="data.list && !data.listType">
      <li v-for="(listItem, key) in data.list" :key="key" v-html="listItem"></li>
    </ul>
    <ol v-if="data.list && data.listType" :style="{'list-style-type': data.listType}">
      <li v-for="(listItem, key) in data.list" :key="key" v-html="listItem"></li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'textlistblock',
  props: ['data'],
  computed: {
    cssClasses() {
      return [this._.get(this.data, 'class', null), this._.get(this.data, 'styleClass', null)]
    }
  }
}
</script>



// WEBPACK FOOTER //
// BlockTextlist.vue?ca532a40